// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"450":"component---src-pages-teste-session-storage-js","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"450":"0554206557e5697443e7","532":"f1c32f1042a457d2bc31","678":"f5c7c5694c3ccaa89e3f","883":"ac1a669020c0e101aaab"}[chunkId] + ".js";
};